import { css } from "@emotion/css";
import styled from "@emotion/styled";

export const permissionsCardTitleCss = css`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const PermissionsCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;

    text-align: center;
`;

export const DeniedIcon = styled.img`
    height: 250px;
`;

export const cardCss = css`
    padding: 20px;
`;
